var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPencilEditWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPencilEdit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup---quick-msg---select-template",
    transform: "translate(-837.000000, -348.000000)",
    fill: "#fff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "QUICK-MESSAGE",
    transform: "translate(317.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "popup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPencilEdit",
    transform: "translate(520.909091, 48.851852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2776389,3.05341614 L14.9669855,6.79348916 L5.62823039,16.2607348 L1.9409755,12.5206617 L11.2776389,3.05341614 Z M17.766486,2.15139628 L16.1211793,0.483452124 C15.4853251,-0.161150708 14.4528293,-0.161150708 13.8148148,0.483452124 L12.2387755,2.08117583 L15.9281222,5.82128362 L17.766486,3.95762604 C18.2596562,3.45763562 18.2596562,2.65135195 17.766486,2.15139628 Z M0.0102665812,17.7776354 C-0.0568747953,18.0839634 0.215942769,18.3584489 0.518147545,18.2839527 L4.62930524,17.2734387 L0.942050352,13.5333657 L0.0102665812,17.7776354 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencilEditWhite);
export default __webpack_public_path__ + "static/media/icPencilEditWhite.d6fbdfee69a049a596c6e49e5a430bd1.svg";
export { ForwardRef as ReactComponent };